import * as React from 'react';

import { cn } from '@rematter/ui-web';

import { ModuleLayout } from '~/shared/layouts/ModuleLayout';
import { NavItem } from '~/shared/routing/createModuleNav';

export type PricingLayoutProps = {
  children: React.ReactNode;
  className?: string;
  moduleNavigation?: NavItem;
};

export const PricingLayout = ({
  children,
  className,
  moduleNavigation,
}: PricingLayoutProps) => (
  <ModuleLayout
    noContentPadding={true}
    moduleNavigation={moduleNavigation}
    className={cn('@PricingLayout', className)}
  >
    {children}
  </ModuleLayout>
);
